import styled from 'styled-components';

import { Text } from '@dreryk/react-components';

export const StyledInfo = styled(Text)`
   display: inline-flex;
`;
StyledInfo.displayName = 'StyledInfo';
